<template>
  <div class='row d-flex full-width'>
    <div v-for="(item,index) in listMenu" :key="index" class='col-12 col-sm-4 col-md-3 q-pa-md'>
      <q-btn class='full-width my-card relative-position' style="margin: 0 auto;overflow:hidden; color:white;min-height:150px" :color="item.backgroundColor" :to='item.ref'>
        <q-card-section class='full-width'>
          <div class='text-h5 text-right'>{{item.name}}
          </div>
          <div class='text-right'>{{ item.description }}</div>
        </q-card-section>
        <q-card-section class='text-left absolute q-my-xl' style='left:-8%;top:20%'>
          <q-icon :name='item.icon' style='font-size: 7em; opacity:0.3' />
        </q-card-section>
      </q-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['listMenu'],
  created () {}
}
</script>
